import { Component } from '@verndale/core';

class SitecoreForm extends Component {
  setupDefaults() {
    this.dom = {
      inputs: this.el.querySelectorAll('.form-field input'),
      selects: this.el.querySelectorAll('.form-field select')
    };
    this.setSelectClasses();
  }

  addListeners() {
    this.dom.inputs.forEach(input => {
      if (input.value) {
        input.parentNode.classList.add('active');
      }

      input.addEventListener('focus', e => {
        e.target.parentNode.classList.add('active');
      });

      input.addEventListener('blur', e => {
        if (!e.target.value) {
          e.target.parentNode.classList.remove('active');
        }
      });
    });
  }

  setSelectClasses() {
    this.dom.selects.forEach(select => {
      const selectWrapper = select.parentNode;
      selectWrapper.classList.add('select-wrapper');
    });
  }

}

export default SitecoreForm;
